import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';

const useEditVersion = () => {
  const { enqueueSnackbar } = useSnackbar();

  const editRequest = (
    updateVersionArgs,
    getVersionList,
    setIsEditModalOpen,
    setEditLoading,
  ) => {
    axiosClient
      .put(`SettingSystem/Application/VersionControl/Update`, updateVersionArgs)
      .then(res => {
        if (res.status === 200) {
          enqueueSnackbar(`ویرایش با موفقیت انجام شد`, { variant: 'success' });
          getVersionList();
          setIsEditModalOpen(false);
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => {
        console.log(err);
        enqueueSnackbar(err?.message, { variant: 'error' });
      })
      .finally(() => setEditLoading(false));
  };
  return [editRequest];
};

export default useEditVersion;
